<template>
  <b-col class="company-details-holder">
    <div class="company-details rounded company-details-vali-hollow-logo">
      <b-row cols="2">
        <b-col v-if="selectedCompany.founded_at">Alapítás éve</b-col>
        <b-col v-if="selectedCompany.founded_at"> {{ selectedCompany.founded_at.slice(0, 4) }} </b-col>

        <b-col v-if="selectedCompany.tax_number[0]">Adószám </b-col>
        <b-col v-if="selectedCompany.tax_number[0]"> {{ selectedCompany.tax_number[0].tax_number }} </b-col>

        <b-col v-if="selectedCompany.main_activities[0].nace_name">Fő tevékenység </b-col>
        <b-col v-if="getCompanyMainActivity">
          {{ getCompanyMainActivity }}
        </b-col>

        <b-col v-if="computedLastYearArbevetel.value">Előző éves nettó árbevétel</b-col>

        <b-col v-if="computedLastYearArbevetel.value">
          {{ computedLastYearArbevetel.value | toCurrency }} {{ computedLastYearArbevetel.currency }}
        </b-col>

        <b-col v-if="computedLastYearMerlegEredmeny.value">Előző éves mérleg eredmény</b-col>

        <b-col v-if="computedLastYearMerlegEredmeny.value"
          >{{ computedLastYearMerlegEredmeny.value | toCurrency }}
          {{ computedLastYearMerlegEredmeny.currency }}
        </b-col>

        <b-col v-if="computedLastEBITDA !== ''">Előző éves EBITDA</b-col>
        <b-col v-if="computedLastEBITDA !== ''"
          >{{ computedLastEBITDA.value | toCurrency }} {{ computedLastEBITDA.currency }}</b-col
        >

        <b-col v-if="computedLastYearExportRevenue !== ''">Előző éves export értékesítés nettó árbevétele</b-col>
        <b-col v-if="computedLastYearExportRevenue !== ''"
          >{{ computedLastYearExportRevenue.value | toCurrency }} {{ computedLastYearExportRevenue.currency }}</b-col
        >

        <b-col v-if="computedLastYearEszkozok.value">Előző éves mérlegfőösszeg</b-col>
        <b-col v-if="computedLastYearEszkozok.value"
          >{{ computedLastYearEszkozok.value | toCurrency }} {{ computedLastYearEszkozok.currency }}</b-col
        >

        <b-col v-if="computedLastYearToke.value">Előző éves saját tőke</b-col>
        <b-col v-if="computedLastYearToke.value"
          >{{ computedLastYearToke.value | toCurrency }} {{ computedLastYearToke.currency }}</b-col
        >

        <b-col
          v-if="
            selectedCompany.registered_capital &&
              selectedCompany.registered_capital.data &&
              selectedCompany.registered_capital.data.length &&
              selectedCompany.registered_capital.data.length > 0
          "
          >Jegyzett tőke</b-col
        >
        <b-col
          v-if="
            selectedCompany.registered_capital &&
              selectedCompany.registered_capital.data &&
              selectedCompany.registered_capital.data.length &&
              selectedCompany.registered_capital.data.length > 0
          "
        >
          {{ numberWithSpace(computedCapital.amount) }} {{ computedCapital.currency }}
        </b-col>

        <b-col v-if="selectedCompany.address[0]">Székhely</b-col>
        <b-col v-if="selectedCompany.address[0]">{{ selectedCompany.address[0].address }}</b-col>

        <b-col v-if="selectedCompany.sites[0]">Telephelyek ({{ selectedCompany.sites.length }} db)</b-col>
        <b-col v-if="selectedCompany.sites[0] && selectedCompany.sites.length <= 5">
          <p v-for="(site, index) in selectedCompany.sites" :key="index">{{ site.address }}</p>
        </b-col>

        <b-col v-if="selectedCompany.sites[0] && selectedCompany.sites.length > 5">
          <p v-for="(site, index) in selectedCompany.sites.slice(0, 5)" :key="index">{{ site.address }}</p>
          <div v-if="showAllSite">
            <p v-for="(site, index) in selectedCompany.sites.slice(5)" :key="index">
              {{ site.address }}
            </p>
          </div>
          <p v-if="!showAllSite">
            <strong @click="showSites" style="cursor: pointer" s
              >További {{ selectedCompany.sites.length - 5 }} telephely..</strong
            >
          </p>
        </b-col>

        <b-col v-if="selectedCompany.branches[0]">Fióktelepek ({{ selectedCompany.branches.length }} db)</b-col>
        <b-col v-if="selectedCompany.branches[0] && selectedCompany.branches.length <= 5">
          <p v-for="(branch, index) in selectedCompany.branches" :key="index">{{ branch.address }}</p>
        </b-col>
        <b-col v-if="selectedCompany.branches[0] && selectedCompany.branches.length > 5">
          <p v-for="(branch, index) in selectedCompany.branches.slice(0, 5)" :key="index">
            {{ branch.address }}
          </p>
          <div v-if="showAllBranch">
            <p v-for="(branch, index) in selectedCompany.branches.slice(5)" :key="index">
              {{ branch.address }}
            </p>
          </div>
          <p v-if="!showAllBranch">
            <strong @click="showBranches" style="cursor: pointer"
              >További {{ selectedCompany.branches.length - 5 }} fióktelep..</strong
            >
          </p>
        </b-col>

        <b-col v-if="selectedCompany.head_count[0] && selectedCompany.head_count[0].count != null"
          >Átlagos statisztikai létszám</b-col
        >
        <b-col v-if="selectedCompany.head_count[0] && selectedCompany.head_count[0].count != null">
          {{ selectedCompany.head_count[0].count }} fő</b-col
        >
      </b-row>
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    selectedCompany: { type: Object, required: true }
  },
  data() {
    return {
      showAllBranch: false,
      showAllSite: false
    }
  },
  computed: {
    getCompanyMainActivity() {
      if (!this.selectedCompany.main_activities?.length) return null
      if (this.selectedCompany.main_activities?.length == 1) return this.selectedCompany.main_activities[0].nace_name
      else {
        // company has more then one main activites, filter that out to have the most recent one
        const filterDeletion = this.selectedCompany.main_activities.filter(function(activity) {
          return activity.deletion === undefined
        })
        return filterDeletion[0].nace_name
      }
    },
    computedLastEBITDA() {
      if (this.selectedCompany.financeData.length) {
        const EBITDA = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'EBITDA')

        if (EBITDA) {
          const lastYearEBITDA = EBITDA.data[EBITDA.data.length - 1]
          const result = {
            value: lastYearEBITDA.value * lastYearEBITDA.multiplier,
            currency: lastYearEBITDA.currency
          }
          return result
        } else {
          return ''
        }
      }
      return ''
    },
    computedLastYearExportRevenue() {
      if (this.selectedCompany.financeData.length) {
        const exportRevenue = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Exportértékesítés nettó árbevétele'
        )

        if (exportRevenue) {
          const lastYearExportRevenue = exportRevenue.data[exportRevenue.data.length - 1]
          const result = {
            value: lastYearExportRevenue.value * lastYearExportRevenue.multiplier,
            currency: lastYearExportRevenue.currency
          }
          return result
        } else {
          return ''
        }
      }
      return ''
    },
    computedLastYearEszkozok() {
      if (this.selectedCompany.financeData.length) {
        const eszkozok = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Eszközök összesen')

        const lastYearEszkozok = eszkozok.data[eszkozok.data.length - 1]
        const result = {
          value: lastYearEszkozok.value * lastYearEszkozok.multiplier,
          currency: lastYearEszkozok.currency
        }
        return result
      }
      return ''
    },
    computedLastYearToke() {
      if (this.selectedCompany.financeData.length) {
        const toke = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Saját tőke')

        const lastYearToke = toke.data[toke.data.length - 1]
        const result = {
          value: lastYearToke.value * lastYearToke.multiplier,
          currency: lastYearToke.currency
        }
        return result
      }
      return ''
    },
    computedLastYearArbevetel() {
      if (this.selectedCompany.financeData.length) {
        const income = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Árbevétel')

        const lastYearIncome = income.data[income.data.length - 1]
        const result = {
          value: lastYearIncome.value * lastYearIncome.multiplier,
          currency: lastYearIncome.currency
        }
        return result
      }
      return ''
    },
    computedLastYearMerlegEredmeny() {
      if (this.selectedCompany.financeData.length) {
        const profitAfterTax = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Adózott eredmény'
        )

        const lastYearResultAfterTax = profitAfterTax.data[profitAfterTax.data.length - 1]
        const result = {
          value: lastYearResultAfterTax.value * lastYearResultAfterTax.multiplier,
          currency: lastYearResultAfterTax.currency
        }
        return result
      }
      return ''
    },
    computedCapital() {
      if (
        this.selectedCompany.registered_capital &&
        this.selectedCompany.registered_capital.data &&
        this.selectedCompany.registered_capital.data.length &&
        this.selectedCompany.registered_capital.data.length > 0
      ) {
        return {
          amount:
            this.selectedCompany.registered_capital.data[this.selectedCompany.registered_capital.data.length - 1]
              .value *
            this.selectedCompany.registered_capital.data[this.selectedCompany.registered_capital.data.length - 1]
              .multiplier,
          currency: this.selectedCompany.registered_capital.data[
            this.selectedCompany.registered_capital.data.length - 1
          ].currency
        }
      } else {
        return { amount: '', currency: '' }
      }
    }
  },
  methods: {
    numberWithSpace(number) {
      if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      }
    },
    showBranches() {
      this.showAllBranch = true
    },
    showSites() {
      this.showAllSite = true
    }
  }
}
</script>

<style scoped>
.company-details {
  background-color: white;
  color: var(--color-gray-04);
  text-align: left;
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 7px;
  border: 1px solid var(--color-gray-02);
}

.company-details .col {
  margin-bottom: 0px !important;
  padding: 15px;
}

.company-details > div > .col {
  margin-top: 7px;
}

.company-details > div > .col:nth-child(odd) {
  color: var(--color-gray-04);
  font-weight: bold;
}

.company-details > div > .col:nth-child(4n + 3),
.company-details > div > .col:nth-child(4n + 4) {
  background-color: var(--color-lightgreen);
}

button {
  width: 250px;
  height: 48px;
  font-weight: bold;
}

.company-details-vali-hollow-logo {
  position: relative;
  overflow: hidden;
}

@media (max-width: 993px) {
  .company-details-holder {
    padding-left: 0;
    padding-right: 0;
  }

  .company-details {
    border: 0px !important;
  }
}
</style>
